import { lazy } from "react";
import Dashboard from "../dashboard/Dashboard";
import Invoice from "../pages/finance/invoice/Invoice.js";
import Bill from "../pages/finance/bill/Bill.js";
import Inventory from "../pages/finance/Inventory/Inventory.js";
import Vendor from "../pages/franchise/vendor/Vendor.js";
import ContractFinance from "../pages/finance/contractF/ContractFinance.js";
import Employees from "../pages/hrm/employees/Employees.js";
import Attendance from "../pages/hrm/timesheet/Attendance.js";
import Payroll from "../pages/hrm/payroll/Payroll.js";
import SalesOrder from "../pages/finance/salesOrder/SalesOrder.js";
import UserRole from "../pages/users/UserRoles.js";
import InvoicePdf from "../pages/finance/invoice/invoicePdf/InvoicePdf.js";
import AreaList from "../pages/area/AreaList.js";
import NearMissDetail from "../pages/healthSafety/nearMiss/NearMissDetail.js";
import InjuryDetailView from "../pages/healthSafety/injury/InjuryDetailView.js";
import LocationDetailView from "../pages/location/LocationDetailView.js";
import EmployeesList from "../pages/hrm/employees/Employees.js";
import SurveyDetail from "../pages/survey/SurveyDetail.js";
import Layout from "../defaultStructure/Layout.js";
import SpecificTaskDetailView from "../pages/crm/sites/sitestask/SpecificTaskDetailVIew.js";
import PrizeList from "../pages/finance/prize/PrizeList.js";
import PanelList from "../pages/finance/panel/PanelList.js";
// import SolarBrandList from "../pages/finance/panel/SolarBrandList.js";
import SolarBrandList from "../pages/finance/masterSolarInverter/SolarBrandList.js";
import PriceDetail from "../pages/finance/prize/PriceDetail.js";
import PaymentReceive from "../pages/finance/paymentReceive/PaymentReceive.js";
import PaymentReceiveDetails from "../pages/finance/paymentReceive/PaymentReceiveDetails.js";
import CustomerLedgerList from "../pages/finance/customerLedger/CustomerLedgerList.js";
import DocumentsList from "../pages/finance/documents/DocumentsList.js";
import DocumentsDetailView from "../pages/finance/documents/DocumentsDetailView.js";
import DmsMasterList from "../pages/crm/DmsMaster/DmsMasterList.jsx";
import NationalPortalDetailView from "../pages/crm/deal/document/NationalPortalDetailView.js";

// import LeadMobileWalkForm from '../pages/crm/lead/walkthrough/LeadMobileWalkForm.js';
// import ForgotPassword from '../pages/login/ForgotPassword.js';
// import LeadProposal from '../pages/crm/lead/leadproposal/LeadProposal.js';
const PayrollDetail = lazy(() =>
  import("../pages/hrm/payroll/PayrollDetail.js")
);
const AttendanceDetail = lazy(() =>
  import("../pages/hrm/timesheet/AttendanceDetail.js")
);
const VendorDetail = lazy(() =>
  import("../pages/franchise/vendor/VendorDetail.js")
);
const SalesOrderDetail = lazy(() =>
  import("../pages/finance/salesOrder/SalesOrderDetail.js")
);
const BillDetail = lazy(() => import("../pages/finance/bill/BillDetail.js"));
const InvoiceDetail = lazy(() =>
  import("../pages/finance/invoice/InvoiceDetail.js")
);
const DealDetail = lazy(() => import("../pages/crm/deal/DealDetail.js"));
const InventoryDetailView = lazy(() =>
  import("../pages/finance/Inventory/InventoryDetail.js")
);
const WalkthroughDetail = lazy(() =>
  import("../pages/crm/walkthrough/WalkthroughDetail.js")
);
const leaddetail = lazy(() => import("../pages/crm/lead/LeadDetail.js"));
const SiteDetailview = lazy(() =>
  import("../pages/crm/sites/SitesDetailview.js")
);
const CompanyDetail = lazy(() =>
  import("../pages/crm/company/CompanyDetail.js")
);
const AreaDetail = lazy(() => import("../pages/area/AreaDetail.js"));
const ClientDetailView = lazy(() =>
  import("../pages/crm/client/ClientDetailView.js")
);
const Sites = lazy(() => import("../pages/crm/sites/SitesList.js"));
const LeadList = lazy(() => import("../pages/crm/lead/LeadList"));
const Walkthrough = lazy(() =>
  import("../pages/crm/walkthrough/Walkthrough.js")
);
const ClientList = lazy(() => import("../pages/crm/client/ClientList.js"));
const CompanyList = lazy(() => import("../pages/crm/company/CompanyList.js"));
const ContractList = lazy(() =>
  import("../pages/crm/contract/ContractList.js")
);
const DealList = lazy(() => import("../pages/crm/deal/DealList.js"));
const Inspection = lazy(() => import("../pages/inspection/Inspection.js"));
const InspectionDetail = lazy(() =>
  import("../pages/inspection/InspectionDetailView.js")
);
const HealthSafetyList = lazy(() =>
  import("../pages/healthSafety/HealthSafetyList.js")
);
const Map = lazy(() => import("../pages/map/Map.js"));
const Location = lazy(() => import("../pages/location/Location.js"));
const Setting = lazy(() => import("../pages/setting/Setting.js"));
const AssetList = lazy(() => import("../pages/asset/AssetList.js"));
const SurveyList = lazy(() => import("../pages/survey/SurveyList.js"));
const AssetCatageory = lazy(() =>
  import("../pages/asset/cataegory/AssetCatageory.js")
);
const AssetType = lazy(() => import("../pages/asset/cataegory/AssetType.js"));
const AssetDetail = lazy(() => import("../pages/asset/detail/AssetDetail.js"));

const LeadsProposal = lazy(() =>
  import("../pages/crm/lead/leadproposal/LeadProposal.js")
);
const DealLead = lazy(() => import("../pages/crm/deal/DealLead.js"));
const DealListMobile = lazy(() =>
  import("../pages/crm/deal/mobileList/DealListMobile.js")
);
const ClientMobileList = lazy(() =>
  import("../pages/crm/client/mobileList/ClientMobileList.js")
);
// const ProposalMobileList = lazy(()=>import('../pages/crm/proposal/mobileList/ProposalMobileList.js'))
const WalkthroughMobileList = lazy(() =>
  import("../pages/crm/walkthrough/mobileList/WalkthrouthMobileList.js")
);
const InspectionMobileList = lazy(() =>
  import("../pages/inspection/mobileList/InspectionMobileList.js")
);
const QuoteList = lazy(() => import("../pages/crm/proposal/QuoteList.js"));
const SiteMobileList = lazy(() =>
  import("../pages/crm/sites/mobileList/SiteMobileList.js")
);
const LocationMobileList = lazy(() =>
  import("../pages/location/mobileList/LocationMobileList.js")
);
const AreaMobileList = lazy(() =>
  import("../pages/area/mobileList/AreaMobileList.js")
);
const HealthSafetyMobileList = lazy(() =>
  import("../pages/healthSafety/mobileList/HealthSafetyMobileList.js")
);
const InvoiceMobileList = lazy(() =>
  import("../pages/finance/invoice/mobileList/InvoiceMobileList.js")
);
const BillMobileList = lazy(() =>
  import("../pages/finance/bill/mobileList/BillMobileList.js")
);
const InventoryMobileList = lazy(() =>
  import("../pages/finance/Inventory/mobileList/InventoryMobileList.js")
);
const SalesOrderMobileList = lazy(() =>
  import("../pages/finance/salesOrder/mobileList/SalesOrderMobileList.js")
);
const VendorMobileList = lazy(() =>
  import("../pages/franchise/vendor/mobileList/VendorMobileList.js")
);
const EmployeesMobileList = lazy(() =>
  import("../pages/hrm/employees/mobileList/EmployeesMobileList.js")
);
const TimesheetMobileList = lazy(() =>
  import("../pages/hrm/timesheet/mobileList/TimesheetMobileList.js")
);
const PayrollMobileList = lazy(() =>
  import("../pages/hrm/payroll/mobileList/PayrollMobileList.js")
);
const CataegoryMobileList = lazy(() =>
  import("../pages/asset/cataegory/mobileList/CataegoryMobileList.js")
);
const AssetTypeMobileList = lazy(() =>
  import("../pages/asset/assetType/mobileList/AssetTypeMobileList.js")
);
const PpeComplianceDetailView = lazy(() =>
  import("../pages/healthSafety/ppeCompliance/PpeComplianceDetailView.js")
);
const SafetyDataDetailView = lazy(() =>
  import("../pages/healthSafety/safetyDataSheet/SafetyDataDetailView.js")
);
const IncidentDetailView = lazy(() =>
  import("../pages/healthSafety/incidentReport/IncidentDetailView.js")
);
const QuoteDetailView = lazy(() =>
  import("../pages/crm/proposal/quoteDetail/QuoteDetailView.js")
);
const WalkthroughDetailView = lazy(() =>
  import("../pages/crm/walkthrough/walkthroughDetail/WalkthroughDetailView.js")
);
const EmployeeDetailView = lazy(() =>
  import("../pages/hrm/employees/EmployeeDetailView.js")
);
const purchaseOrderList = lazy(() =>
  import("../pages/finance/purchaseOrder/purchaseOrderList.js")
);
const TaskMaster = lazy(() => import("../pages/crm/taskMaster/TaskMaster.js"));
const LeadTasks = lazy(() =>
  import("../pages/crm/taskMaster/taskMasterTabs/AddTaskLeads.js")
);
const DepartmentList = lazy(() =>
  import("../pages/hrm/department/Department.js")
);
const Home = lazy(() => import("../pages/home/Home.js"));
const LeadWalkList = lazy(() =>
  import("../pages/crm/lead/walkthrough/LeadWalkList.js")
);
const LeadMobileWalkForm = lazy(() =>
  import("../pages/crm/lead/walkthrough/LeadMobileWalkForm.js")
);
const InventorySolarPanelDetail = lazy(() =>
  import("../pages/finance/Inventory/InventorySolarPanelDetail.js")
);
const InventoryInverterDetail = lazy(() =>
  import("../pages/finance/Inventory/InventoryInverterDetail.js")
);
// const EmployeesList = lazy(() => import('../pages/hrm/employees/Employees.js'))
// const QuoteDetailView = lazy (() => import ("../pages/crm/proposal/quoteDetail/QuoteDetailView.js"))
// const WalkthroughDetailView = lazy (() => import ("../pages/crm/walkthrough/walkthroughDetail/WalkthroughDetailView.js"))
const routes = [
  // { path: "/", exact: true, name: "Home" },
  { path: "/dashboard", element: Dashboard },
  { path: "/lead-list", element: LeadList },
  { path: "/walkthrough", element: Walkthrough },
  { path: "/client-list", element: ClientList },
  { path: "/company-list", element: CompanyList },
  { path: "/contract-list", element: ContractList },
  { path: "/deal-list", element: DealList },
  { path: "/inspection", element: Inspection },
  { path: "/quote-list", element: QuoteList },
  { path: "/inspection-detail", element: InspectionDetail },
  { path: "/map", element: Map },
  { path: "/location", element: Location },
  { path: "/setting", element: Setting },
  { path: "/invoice", element: Invoice },
  { path: "/bill", element: Bill },
  { path: "/inventory", element: Inventory },
  { path: "/contract-finance", element: ContractFinance },
  { path: "/vendor", element: Vendor },
  { path: "/employees", element: Employees },
  { path: "/attendance-list", element: Attendance },
  { path: "/payroll", element: Payroll },
  { path: "/sales-order", element: SalesOrder },
  { path: "/sites", element: Sites },
  { path: "/site-detail-view", element: SiteDetailview },
  { path: "/company-detail-view", element: CompanyDetail },
  { path: "/area-detail-view", element: AreaDetail },
  { path: "/user-role", element: UserRole },
  { path: "/lead-detail-view", element: leaddetail },
  { path: "/client-detail-view", element: ClientDetailView },
  { path: "/area-list", element: AreaList },
  { path: "/walkthrough-detail-view", element: WalkthroughDetail },
  { path: "/deal-detail-view", element: DealDetail },
  { path: "/inventory-detail-view", element: InventoryDetailView },
  { path: "/invoice-detail-view", element: InvoiceDetail },
  { path: "/bill-detail-view", element: BillDetail },
  { path: "/salesorder-detail-view", element: SalesOrderDetail },
  { path: "/vendor-detail-view", element: VendorDetail },
  { path: "/attendance-detail-view", element: AttendanceDetail },
  { path: "/payroll-detail-view", element: PayrollDetail },
  { path: "/Asset-List", element: AssetList },
  { path: "/Asset-Category", element: AssetCatageory },
  { path: "/Asset-Type", element: AssetType },
  { path: "/Asset-detail-view", element: AssetDetail },
  { path: "/leads-proposal-page", element: LeadsProposal },
  { path: "/lead-deal-page", element: DealLead },
  { path: "/health-safety-list", element: HealthSafetyList },
  { path: "/invoice-Pdf", element: InvoicePdf },
  { path: "/deal-mobile-list", element: DealListMobile },
  { path: "/client-mobile-list", element: ClientMobileList },
  // { path: '/proposal-mobile-list', element:ProposalMobileList },
  { path: "/walkthrough-mobile-list", element: WalkthroughMobileList },
  { path: "/inspection-mobile-list", element: InspectionMobileList },
  { path: "/site-mobile-list", element: SiteMobileList },
  { path: "/location-mobile-list", element: LocationMobileList },
  { path: "/area-mobile-list", element: AreaMobileList },
  { path: "/healthsafety-mobile-list", element: HealthSafetyMobileList },
  { path: "/invoice-mobile-list", element: InvoiceMobileList },
  { path: "/bill-mobile-list", element: BillMobileList },
  { path: "/inventory-mobile-list", element: InventoryMobileList },
  { path: "/salesorder-mobile-list", element: SalesOrderMobileList },
  { path: "/vendor-mobile-list", element: VendorMobileList },
  { path: "/employees-mobile-list", element: EmployeesMobileList },
  { path: "/timesheet-mobile-list", element: TimesheetMobileList },
  { path: "/payroll-mobile-list", element: PayrollMobileList },
  { path: "/cataegory-mobile-list", element: CataegoryMobileList },
  { path: "/asset-type-mobile-list", element: AssetTypeMobileList },
  { path: "/injury-detail-view", element: InjuryDetailView },
  { path: "/safetydata-detail-view", element: SafetyDataDetailView },
  { path: "/ppecompliance-detail-view", element: PpeComplianceDetailView },
  { path: "/incident-detail-view", element: IncidentDetailView },
  { path: "/nearmiss-detail-view", element: NearMissDetail },
  { path: "/location-detail-view", element: LocationDetailView },
  { path: "/employee-list", element: EmployeesList },
  { path: "/quote-detail-view", element: QuoteDetailView },
  { path: "/walk-through-detail-view", element: WalkthroughDetailView },
  { path: "/employee-detail-view", element: EmployeeDetailView },
  { path: "/purchaseOrder-list-view", element: purchaseOrderList },
  { path: "/survey-list-view", element: SurveyList },
  { path: "/survey-detail-view", element: SurveyDetail },
  { path: "/task-detail-view", element: SpecificTaskDetailView },
  { path: "/leaddetail-walk-form", element: LeadMobileWalkForm },
  { path: "/lead-walk-list-mobile", element: LeadWalkList },
  // { path: '/signup', element: Signup },
  { path: "/taskmaster", element: TaskMaster },
  { path: "/lead-task", element: LeadTasks },
  { path: "/department-list", element: DepartmentList },
  { path: "/home", element: Home },
  // { path: '/dashboard', element: Layout },
  { path: "/price-list", element: PrizeList },
  { path: "/price-detail", element: PriceDetail },
  { path: "/panel-list", element: PanelList },
  { path: "/masters-list", element: SolarBrandList },
  { path: "/inventory-solar-panel-detail", element: InventorySolarPanelDetail },
  { path: "/inventory-inverter-detail", element: InventoryInverterDetail },
  { path: "/payment-receive", element: PaymentReceive },
  { path: "/payment-receive-detail", element: PaymentReceiveDetails },
  { path: "/customerLedger", element: CustomerLedgerList },
  { path: "/term&condition", element: DocumentsList },
  { path: "/condition-view", element: DocumentsDetailView },
  { path: "/dmsmaster", element: DmsMasterList },
  { path: "/nationa-portal-detail", element: NationalPortalDetailView },
];
export default routes;
